import React from 'react'

export const Accordion = React.lazy(() => import('./accordion/AccordionComponent'))
export const UpcomingMovies = React.lazy(() => import('./upcomingMovies/UpcomingMoviesComponent'))
export const HeaderCarousel = React.lazy(() => import('./headerCarousel/HeaderCarouselComponent'))
export const OmniFilter = React.lazy(() => import('./omniFilter/OmniFilterComponent'))
export const FilmDetails = React.lazy(() => import('./filmDetails/FilmDetailsComponent'))
export const DateShowtimePicker = React.lazy(() => import('./dateShowtimePicker/DateShowtimePickerComponent'))
export const ModalSitePicker = React.lazy(() => import('./modalSitePicker/ModalSitePickerComponent'))
export const SingleFilter = React.lazy(() => import('./singleFilter/SingleFilterComponent'))
export const CompositeFilter = React.lazy(() => import('./compositeFilter/CompositeFilterComponent'))
export const LocateMe = React.lazy(() => import('./locateMe/LocateMeComponent'))
export const ImageTextList = React.lazy(() => import('./imageTextList/ImageTextListComponent'))
export const CustomerDetailsForm = React.lazy(() => import('./customerDetailsForm/CustomerDetailsFormComponent'))

export const SectionBox = React.lazy(() => import('./sectionBox/SectionBoxComponent'))
export const MemberContext = React.lazy(() => import('./memberContext/MemberContextComponent'))
export const SubscriptionNotification = React.lazy(
    () => import('./subscriptionNotification/SubscriptionNotificationComponent')
)
export const UpcomingBookingsComponent = React.lazy(() => import('./upcomingBookings/UpcomingBookingsComponent'))

export const MemberContactPreferences = React.lazy(() => import('./memberContactPreferences/MemberContactPreferences'))
export const MemberGenrePreferences = React.lazy(() => import('./memberPreferredGenres/MemberGenrePreferences'))
export const MemberCinemaPreferences = React.lazy(() => import('./memberCinemaPreferences/MemberCinemaPreferences'))

export const Divider = React.lazy(() => import('./divider/Divider'))
// export const GlobalAnnouncement = React.lazy(() => import('./globalAnnouncement/GlobalAnnouncementComponent'))
// export const LocationAnnouncement = React.lazy(() => import('./locationAnnouncement/LocationAnnouncementComponent'))

// membership
export const SignIn = React.lazy(() => import('./membership/signIn/SignIn'))
export const SignUp = React.lazy(() => import('./membership/signup/SignUp'))
export const ForgotPassword = React.lazy(() => import('./membership/forgotPassword/ForgotPasswordComponent'))
export const PasswordResetForm = React.lazy(() => import('./membership/passwordResetForm/PasswordResetFormComponent'))
export const accountDetails = React.lazy(() => import('./membership/accountDetails/AccountDetailsComponent'))
export const personalDetails = React.lazy(() => import('./membership/personalDetails/PersonalDetailsComponent'))

export const TextColumn = React.lazy(() => import('./textColumn/TextColumnComponent'))
export const PagePromotionCard = React.lazy(() => import('./pagePromotionCard/PagePromotionCard'))

export const FilmList = React.lazy(() => import('./filmList/FilmListComponent'))
export const ArcadeCards = React.lazy(() => import('./arcadeCards/ArcadeCards'))
export const JumpHeading = React.lazy(() => import('./jumpHeading/JumpHeading'))
export const MemberBalanceSubscription = React.lazy(
    () => import('./memberBalanceSubscription/MemberBalanceSubscription')
)
export const SalesforceForm = React.lazy(() => import('./salesforceForm/SalesforceForm'))
export const ArcadeCardBalanceChecker = React.lazy(() => import('./arcadeCardBalanceChecker/BalanceChecker'))
export const LoomCard = React.lazy(() => import('./loomCard/LoomCard'))

export const LinkGroupWithHeading = React.lazy(() => import('./linkGroupWithHeading/LinkGroupWithHeading'))
export const FooterLinksSection = React.lazy(() => import('./footerLinksSection/FooterLinksSection'))
